import { INavigationItem } from './types';
import RouteNavigation from '../constants/RouteNavigation';

export const navigationHome: INavigationItem = {
  id: '0',
  keyTranslate: 'home',
  icon: 'home',
  url: RouteNavigation.Home,
  allowAnonymous: true,
};